
export type RaEventType = string;

/*export enum RaEventType {
    exit,
    keepAlive,
    trainingsession_start,
    trainingsession_close,
    booksession_start,
    booksession_close,
    modal_event,
    assignment_load,
    readRecordEvent}*/

/**
 * Base class which all events extend
 */
export class RaEvent {

    constructor(private _type:RaEventType) {
    }

    public get type():RaEventType {
        return this._type;
    }
}